import {AnyPcbNode, EditorModes, PcbNodesMap, createActionRecordAction} from "@buildwithflux/core";
import {AppThunkAction} from "storeTypes";

/**
 * Consider using dispatch(addNodesThunk(...)) instead of dispatching this action directly: it provides injected arguments
 */
export const addNodes = createActionRecordAction(
    "addNodes",
    (nodes: PcbNodesMap<AnyPcbNode>, editorMode: EditorModes) => {
        return {
            payload: {
                nodes,
                canUndo: true,
                inPcbEditor: editorMode === EditorModes.pcb,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,
            },
        };
    },
    "added PCB nodes",
);

export function addNodesThunk(nodes: PcbNodesMap<AnyPcbNode>): AppThunkAction<void> {
    return (_dispatch, _getState, services) => {
        const {editorMode} = services.usePersistedDocumentUiStore.getState();
        // Dispatch directly to Zustand (bypassing Redux middleware bridge)
        services.documentStore.getState().addNodes(nodes, editorMode === EditorModes.pcb);
    };
}
